<template>
  <!--专用号依据---明细-惊天地-->
  <h-form-page :title="h_i18n('9c647915087c42663e140d555d22e102')" @inspection-update="inspectionUpdate">
    <div class="detail-all-list">
      <div class="detail-title">
        <!-- 专用号依据明细 -->
        <div class="detail-title-left">{{ h_i18n('9c647915087c42663e140d555d22e102') }}</div>
        <div class="detail-title-right">
          <!-- 物料大类： -->
          <div class="detail-title-right-item">{{ h_i18n('70ab9180fbc7101df91637a8c7372a7c') }}{{ tableData.materielCategoryName }}</div>
          <!-- 专用号： -->
          <div class="detail-title-right-item">{{ h_i18n('7c7fefb36371a5a9ab5338c98790c67c') }}{{ tableData.mtlNo }}</div>
          <!-- 物料名称： -->
          <div class="detail-title-right-item">{{ h_i18n('7a0ae7305076f170b4a920ef5f3f04f9') }}{{ tableData.mtlName }}</div>
        </div>
      </div>
      <div class="detail-body">
        <table class="detail-body-table" cellspacing="0">
          <colgroup>
            <col v-for="item in 20" width="5%"/>
          </colgroup>
          <tbody class="detail-body-table-body" v-for="item in list">
          <tr class="detail-table-row colspan">
            <td colspan="20" class="detail-table-col">
              <div class="detail-body-title">
                <!-- 标准类别： -->
                <div class="detail-body-title-one">{{ h_i18n('8183ea1d2767e7558ac7e2a816afcf97') }}{{ item.templateTypeName }}</div>
                <!-- 标准编号： -->
                <div class="detail-body-title-two">{{ h_i18n('7e217ea649098e03f615a99ae9c692a8') }}{{ item.templateCode }}</div>
                <!-- 标准名称： -->
                <div class="detail-body-title-two">{{ h_i18n('006efbdbae28c75b479bcf69d7265272') }}{{ item.templateName }}</div>
              </div>
            </td>
          </tr>
          <tr class="detail-table-row title">
            <!-- 检验类别 -->
            <th class="detail-table-col th">{{ h_i18n('f4aadbe7c1febb0b5cd8c1a9164319e3') }}</th>
            <!-- 检验项目 -->
            <th class="detail-table-col th">{{ h_i18n('222c0f1a6341c9df01ca58fc982db93b') }}</th>
            <!-- 检验项目描述 -->
            <th class="detail-table-col th" colspan="3">{{ h_i18n('eb922f88d8c12b6442cbee3b86090312') }}</th>
            <!-- 重要性 -->
            <th class="detail-table-col th">{{ h_i18n('4626e7457839719f5fa1b08526e5e3fd') }}</th>
            <!-- 适用范围 -->
            <th class="detail-table-col th">{{ h_i18n('901c0de56e3d0915b902ba4936d73b2f') }}</th>
            <!-- 检查水平 -->
            <th class="detail-table-col th">{{ h_i18n('0cf684d33849528278363c0e3991cb82') }}</th>
            <th class="detail-table-col th">AQL</th>
            <!-- 判别水平 -->
            <th class="detail-table-col th">{{ h_i18n('be1fa802bb9d3e890344d1033fbf0933') }}</th>
            <th class="detail-table-col th">RQL</th>
            <!-- 数据类别 -->
            <th class="detail-table-col th">{{ h_i18n('bd9d32f9b63c551e252decdf8b3c854b') }}</th>
            <th class="detail-table-col th">min</th>
            <th class="detail-table-col th">max</th>
            <!-- 单位 -->
            <th class="detail-table-col th">{{ h_i18n('f2996845b6bf0a07fe26f74f35e42ebe') }}</th>
            <!-- 周期（天） -->
            <th class="detail-table-col th">{{ h_i18n('dd811bb7db3872285166bbd376ef6d36') }}</th>
            <!-- 检验工具 -->
            <th class="detail-table-col th">{{ h_i18n('15b303c7dc3de712a4b5af97e3d8dd4e') }}</th>
            <!-- 检验方法 -->
            <th class="detail-table-col th">{{ h_i18n('6bc2c14d1794c3c913106f61e9de325f') }}</th>
            <!-- 易出现的缺陷 -->
            <th class="detail-table-col th" colspan="2">{{ h_i18n('33a235ddd0ca1b316a8f442493f1274e') }}</th>
          </tr>
          <tr class="detail-table-row" v-for="value in item.details">
            <td class="detail-table-col">{{ value.itemCodeName }}</td>
            <td class="detail-table-col">{{ value.itemName }}</td>
            <td class="detail-table-col" colspan="3">{{ value.remark }}</td>
            <td class="detail-table-col">{{ value.importancePropertiesName }}</td>
            <td class="detail-table-col">{{ incomingForm(value) }}</td>
            <td class="detail-table-col">{{ value.checkLevelName }}</td>
            <td class="detail-table-col">{{ value.aqlProperty }}</td>
            <td class="detail-table-col">{{ value.deterName }}</td>
            <td class="detail-table-col">{{ value.rqlProperty }}</td>
            <td class="detail-table-col">{{ value.dataType }}</td>
            <td class="detail-table-col">{{ value.min }}</td>
            <td class="detail-table-col">{{ value.max }}</td>
            <td class="detail-table-col">{{ value.unit }}</td>
            <td class="detail-table-col">{{ value.itemCycle }}</td>
            <td class="detail-table-col">{{ value.tool }}</td>
            <td class="detail-table-col">{{ value.checkMethod }}</td>
            <td class="detail-table-col" colspan="2">{{ value.easyFault }}</td>
          </tr>
          </tbody>

        </table>


      </div>
    </div>
  </h-form-page>
</template>




<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

export default {
  name: "EnterpriseStandardDetail",
  data() {
    return {
      list: [],
      tableData: {}
    }
  },
  mounted() {
    this.searchTableList()
  },
  methods: {
    h_i18n,
    //更新页面高度
    inspectionUpdate(height) {
      this.postThisPageHeight()
    },
    incomingForm(row) {
      if (row.isAll === "Y") {
        // 入厂&型式
        return h_i18n('75ec5b5f8b5a4d3e4508e1fb9e91bc3c')
      } else {
        if (row.isPart === "Y") {
          // 入厂
          return h_i18n('38484a93d62fdfdd5dc808da53657825')
        } else {
          // 型式
          return h_i18n('2b1c6525f8306d39c387bd6b9ecbf830')
        }
      }
    },
    searchTableList() {
      // 数据查询中...
      this.startLoading(h_i18n('f2a88edc8adb598632ba1c6f89279b89'))
      return this.$http({
        method: "get",
        url: "/base/patternPlan/searchStandardDetails",
        params: {
          mtlNo: this.$route.query.mtlNo
        },
      }).then((res) => {
        if (res.data.code === "200") {
          let targetCategory = res.data.data["templateTypes"] //企标、国标 type...
          let enterpriseStandard = res.data.data["templates"] //企标
          let particulars = res.data.data["materialCodDetails"] //明细
          let particularsCustom = res.data.data["materialCodDetailNoTemplate"] //自定义
          let correspondenceRule = res.data.data["itemIdAndTemplateNameReflects"] //对应规则
          let checkLevels = res.data.data["checkLevels"] //检查水平
          let deterLevels = res.data.data["deterLevels"] //判别水平
          let equipmentTypes = res.data.data["equipmentTypes"] //设备类型
          let importanceProperties = res.data.data["importanceProperties"] //重要性
          let itemCodes = res.data.data["itemCodes"] //检验类别
          this.tableData.materielCategoryName = res.data.data["materielCategoryName"] //table物料大类
          this.tableData.mtlName = res.data.data["materialCod"].mtlName
          this.tableData.mtlNo = res.data.data["materialCod"].mtlNo

          particulars = particulars.map(v => {
            return {
              ...v,
              itemCodeName: itemCodes.filter(value => value.valueId === v.itemCode)[0]?.valueName,
              deterName: deterLevels.filter(value => value.valueId === v.deterLevel)[0]?.valueName,
              checkLevelName: checkLevels.filter(value => value.valueId === v.checkLevel)[0]?.valueName,
              importancePropertiesName: importanceProperties.filter(value => value.valueId === v.importanceProperty)[0]?.valueName
            }
          })
          particularsCustom = particularsCustom.map(v => {
            return {
              ...v,
              itemCodeName: itemCodes.filter(value => value.valueId === v.itemCode)[0]?.valueName,
              deterName: deterLevels.filter(value => value.valueId === v.deterLevel)[0]?.valueName,
              checkLevelName: checkLevels.filter(value => value.valueId === v.checkLevel)[0]?.valueName,
              importancePropertiesName: importanceProperties.filter(value => value.valueId === v.importanceProperty)[0]?.valueName
            }
          })

          let list = []

          for (let i = 0; i < enterpriseStandard.length; i++) {
            list.push({
              templateCode: enterpriseStandard[i].templateCode,
              templateId: enterpriseStandard[i].templateId,
              templateName: enterpriseStandard[i].templateName,
              templateType: enterpriseStandard[i].templateType,
              details: correspondenceRule.filter(v => v.templateId === enterpriseStandard[i].templateId).map(v => v.itemId)
            })
          }

          list.forEach(v => {
            v.templateTypeName = targetCategory.filter(value => value.valueId === parseInt(v.templateType))[0].valueName
            v.details = v.details.map(vl => {
              return particulars.filter(value => value.itemId === vl)[0]
            })
          })

          // if (particularsCustom.length !== 0) {
          //   list.push({
          //     templateCode:"--",
          //     templateName:"自定义企标",
          //
          //   })
          // }
          //自定义的暂时没展示
          this.list = list

          console.log(list)
        }
        this.closeLoading()
      }).catch((err) => {
        if (err.toString() !== "Cancel") {
          // this.error("查询失败" + err)
          console.log(err)
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.detail-all-list {
  padding: 10px;
  background-color: #fff;
  border-radius: 8px;

  .detail-title {
    min-height: 90px;
    //width: 100%;
    display: flex;
    border: 1px solid #ccc;

    .detail-title-left {
      font-size: 24px;
      font-weight: 900;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }

    .detail-title-right {
      width: 500px;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #ccc;
      flex: none;

      .detail-title-right-item {
        border-top: 1px solid #ccc;
        width: 100%;
        min-height: 30px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding: 10px;
        font-size: 14px;
      }

      .detail-title-right-item:first-child {
        border-top: 0;
      }
    }
  }

  .detail-body {
    border: 1px solid #ccc;
    border-top: 0;
    margin-top: 10px;

    .detail-body-title {
      display: flex;
      height: 40px;
      font-size: 16px;
      align-items: center;
      padding: 0 10px;
    }

    .detail-body-table {
      width: 100%;

      .colspan {
        background-color: #ccc;
      }

      .title {
        background-color: #DDEDFE;
        font-size: 14px;
      }

      .detail-table-row {

        .detail-table-col {
          min-height: 35px;
          text-align: center;
          padding: 5px;
          border-bottom: 1px solid #ccc;
          border-left: 1px solid #ccc;
          font-size: 14px;

          .detail-body-title {

            .detail-body-title-one {

            }

            .detail-body-title-two {
              margin-left: 30px;
            }
          }
        }

        .detail-table-col:first-child {
          border-left: 0;
        }

        .th {
          font-weight: 400;
          height: 30px;
          //border-bottom: 0;
        }
      }

      .detail-table-row:last-child {
        .detail-table-col {
          border-bottom: 0;
        }
      }
    }
  }
}
</style>